import posthog from 'posthog-js';
import * as Sentry from '@sentry/react';

import { identifyUser } from 'utils/analytics';

export default function debugSetup() {
  const environment = process.env.REACT_APP_MODE;
  const sentryApp = process.env.REACT_APP_SENTRY_APP_ID;
  const posthogApp = process.env.REACT_APP_POSTHOG_KEY;

  if (sentryApp) {
    Sentry.init({
      dsn: sentryApp,
      environment,
      release: `${process.env.REACT_APP_VERSION}-${process.env.REACT_APP_CURRENT_GIT_SHA}`,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0.1 // Start low to control costs
    });
  }

  if (posthogApp) {
    posthog.init(posthogApp, {
      api_host: process.env.REACT_APP_POSTHOG_HOST,
      disable_session_recording: environment !== 'PRODUCTION'
    });
  }

  identifyUser();
}
